import { ReactElement } from 'react';
import styles from './invite.module.scss';
import { UIAvatar, UIButton, UISpacer, UIText } from '@/ui';
import { useCompaniesTranslation } from '../hooks';

type InviteProps = {
    name: string;
    image: string;
    acceptLoading?: boolean;
    declineLoading?: boolean;
    disabled?: boolean;
    allowDecline?: boolean;
    onAccept?: () => void;
    onDecline?: () => void;
};

export function Invite(props: InviteProps): ReactElement {
    const {
        name,
        image,
        acceptLoading,
        declineLoading,
        disabled,
        allowDecline = true,
        onAccept,
        onDecline
    } = props;

    const { t } = useCompaniesTranslation();

    return (
        <div className={styles.container}>
            <div className={styles.nameContainer}>
                <UIAvatar
                    img={image}
                    alt={t('components.invite.image_alt')}
                    size={75}
                />
                <UISpacer />
                <UIText variant={'large'} bold>
                    {name}
                </UIText>
            </div>
            <UISpacer />
            <div className={styles.buttonContainer}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1
                    }}
                >
                    <UIButton
                        variant="primary"
                        loading={acceptLoading}
                        disabled={disabled || declineLoading}
                        onClick={onAccept}
                    >
                        {t('components.invite.join')}
                    </UIButton>
                </div>
                {allowDecline && (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1
                        }}
                    >
                        <UIButton
                            variant="danger"
                            loading={declineLoading}
                            disabled={disabled || acceptLoading}
                            onClick={onDecline}
                        >
                            {t('components.invite.decline')}
                        </UIButton>
                    </div>
                )}
            </div>
        </div>
    );
}
